import { createReducer } from "../redux-utils.js";
import { clearAdvancedSearch } from "./advanced-search.js";
import { SHOW_NAVBAR_DIALOG } from "@/redux/action-types.ts";

export interface INavbarState {
  showAppInfo?: boolean;
  showProjectsMenu?: boolean;
  showVisualizePanel?: boolean;
  showPlaybooksPanel?: boolean;
  showCombinedRegistrationNgsWizard?: boolean;
  showBlastPlaybookWizard?: boolean;
  showAuditReportForm?: boolean;
  showCreateProjectDialog?: boolean;
  showAdvancedSearchPanel?: boolean;
  showNotificationPanel?: boolean;
  showSamplePlaybookWizard?: boolean;
  showFileBrowser?: boolean;
}

const initialState: INavbarState = {
  showAppInfo: false,
  showProjectsMenu: false,
  showVisualizePanel: false,
  showPlaybooksPanel: false,
  showCombinedRegistrationNgsWizard: false,
  showBlastPlaybookWizard: false,
  showAuditReportForm: false,
  showCreateProjectDialog: false,
  showAdvancedSearchPanel: false,
  showNotificationPanel: false,
  showFileBrowser: false,
};

export default createReducer(initialState, {
  [SHOW_NAVBAR_DIALOG]: (state: INavbarState, payload: INavbarState): INavbarState => {
    return { ...state, ...payload };
  },
});

export function showNavbarElement(settings: INavbarState) {
  return (dispatch, getState) => {
    // element-specific cleanup actions
    if (getState().navBar.showAdvancedSearchPanel === true && settings.showAdvancedSearchPanel === false) {
      dispatch(clearAdvancedSearch());
    }
    // changing the visibility
    dispatch({
      type: SHOW_NAVBAR_DIALOG,
      payload: settings,
    });
  };
}
